<template>
  <section>
    <base-card>
      <h2>{{ fullName }}</h2>
      <h3>{{ age }} years old</h3>
    </base-card>
  </section>
  <section>
    <base-card>
      <header>
        <h2>Interested? Reach out now</h2>
        <base-button link :to="contactLink">Contact </base-button>
      </header>
      <router-view></router-view>
    </base-card>
  </section>
  <section>
    <base-card>
      <base-badge
        v-for="achievement in achievements"
        :key="achievement"
        :type="achievement"
        :title="achievement"
      ></base-badge>
      <p>{{ description }}</p>
    </base-card>
  </section>
</template>

<script>
export default {
  props: ['id'],
  data() {
    return {
      selectedSkipper: null
    };
  },
  computed: {
    fullName() {
      return (
        this.selectedSkipper.firstName + ' ' + this.selectedSkipper.lastName
      );
    },
    achievements() {
      return this.selectedSkipper.achievements;
    },

    age() {
      return this.selectedSkipper.age;
    },

    contactLink() {
      return this.$route.path + '/' + this.id + '/contact';
    },
    description() {
      return this.selectedSkipper.description;
    }
  },

  created() {
    this.selectedSkipper = this.$store.getters.skippers.find(
      skipper => skipper.id === this.id
    );
  }
};
</script>

<style></style>
